import { render, staticRenderFns } from "./enterstd_bookingroom.vue?vue&type=template&id=b0b2e190&scoped=true"
import script from "./enterstd_bookingroom.vue?vue&type=script&lang=js"
export * from "./enterstd_bookingroom.vue?vue&type=script&lang=js"
import style0 from "./enterstd_bookingroom.vue?vue&type=style&index=0&id=b0b2e190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b2e190",
  null
  
)

export default component.exports